import { Cookie } from '@nuxt-common/util/app/utils/cookie';
import CacheManager from '@nuxt-common/util/app/utils/cacheManager';

export const cleanSignInForDevMode = () => {
  Cookie.set('SignedIn', '0');
};

export const cleanRegistryInfo = () => {
  sessionStorage.removeItem('registryFetch');
  localStorage.removeItem('userRegistries');
};

export const cleanLoyaltyInfo = (isMcom) => {
  const srKey = `hnfsr_${Cookie.get(isMcom ? 'macys_online_uid' : 'bloomingdales_online_uid')}`;
  CacheManager.removePersistent('isLoyaltyUser');
  CacheManager.removePersistent(srKey);
};
